import React from 'react';

import AttachmentModal from './AttachmentModal';
import CancelLeaveModal from './CancelLeaveModal';
import CommentModal from './CommentModal';
import Leaves from './Leave';
import LeaveBalanceReportModal from './LeaveBalanceReportModal';


const Leave = () => (
  <>
    <Leaves />
    <AttachmentModal />
    <CommentModal />
    <CancelLeaveModal />
    <LeaveBalanceReportModal />
  </>
);

export default Leave;
